import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * PhoneNumberInput (react-phone-input-2) emits dial code + digits without a
 * leading "+" (e.g. "12015550123") and seeds "1" when empty. Normalize that to
 * E.164, or null when empty/invalid.
 */
export const toE164Phone = (value?: string | null): string | null => {
  const digits = (value ?? "").replace(/\D/g, "");
  if (!digits) return null;
  const parsed = parsePhoneNumberFromString(`+${digits}`);
  return parsed && parsed.isValid() ? (parsed.number as string) : null;
};

export const isValidPhoneInput = (value?: string | null): boolean =>
  toE164Phone(value) !== null;
